import React, { useState, useRef } from "react";
import { motion, AnimatePresence, useScroll, useTransform } from "framer-motion";
import { Users, Sprout, Brain, Heart, ChevronDown } from "lucide-react";
import { Reveal } from "./Reveal";

const items = [
  { icon: Users, title: "Gezinstherapie", text: "Ik help jullie de verbinding en communicatie binnen het gezin te versterken." },
  { icon: Sprout, title: "Individuele begeleiding", text: "Een plek waar jouw verhaal centraal staat, waar we zoeken naar meer inzicht, rust en evenwicht." },
  { icon: Brain, title: "ADHD & ASS", text: "Brede expertise en ervaring met neurodiversiteit in al haar facetten." },
  { icon: Heart, title: "Warm & professioneel", text: "Een veilige plek waar je mag zijn wie je bent, met alles wat daarbij hoort." },
];

export const USP = () => {
  const [open, setOpen] = useState(-1);
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  const scale = useTransform(scrollYProgress, [0, 0.5, 1], [1.1, 1, 1.1]);

  return (
    <section ref={ref} className="relative overflow-hidden py-16 md:py-28 my-6 md:my-10">
      <motion.div style={{ y, scale }} className="absolute inset-0 -top-[16%] h-[132%]">
        <img
          src="/calm-band.webp"
          alt=""
          aria-hidden="true"
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </motion.div>
      <div className="absolute inset-0 bg-kern-dark/45" />
      <div className="relative max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {items.map((it, i) => {
          const Icon = it.icon;
          const isOpen = open === i;
          return (
            <Reveal key={it.title} delay={i * 0.08}>
              <motion.div
                data-testid={`usp-card-${i}`}
                whileHover={{ y: -6 }}
                transition={{ type: "spring", stiffness: 300, damping: 22 }}
                className="h-full bg-white rounded-[28px] lg:rounded-[32px] p-5 md:p-8 shadow-[0_10px_40px_rgba(79,80,72,0.05)] hover:shadow-[0_18px_50px_rgba(79,80,72,0.1)] transition-shadow duration-300"
              >
                <button
                  data-testid={`usp-toggle-${i}`}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center gap-4 text-left lg:block lg:cursor-default"
                  aria-expanded={isOpen}
                >
                  <span className="w-12 h-12 lg:w-14 lg:h-14 rounded-full bg-kern-sage/25 flex items-center justify-center shrink-0 lg:mb-6">
                    <Icon size={24} className="text-kern-olive" strokeWidth={1.6} />
                  </span>
                  <h3 className="flex-1 font-serif text-xl lg:text-2xl text-kern-dark lg:mb-3">
                    {it.title}
                  </h3>
                  <ChevronDown
                    size={20}
                    className={`lg:hidden text-kern-taupe shrink-0 transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
                  />
                </button>

                {/* Desktop: tekst altijd zichtbaar */}
                <p className="hidden lg:block text-sm text-kern-taupe leading-relaxed">
                  {it.text}
                </p>

                {/* Mobiel: tekst inklapbaar */}
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      key="m"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                      className="lg:hidden overflow-hidden"
                    >
                      <p className="pt-4 text-sm text-kern-taupe leading-relaxed">{it.text}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            </Reveal>
          );
        })}
        </div>
      </div>
    </section>
  );
};
